// src/pages/DashboardView/DashboardView.jsx
import React from 'react';
import usePersistentLanguage from '../hooks/usePersistentLanguage';
import { useNavigate } from 'react-router-dom';
import styles from './DashboardView.module.css';
import AppLayout from '../components/AppLayout';

// 1) Translation strings for English and Arabic
const translations = {
  en: {
    workersDashboard: 'Workers Dashboard',
    explanationText:
      'Welcome to the workers dashboard. Manage product stock adjustments from here.',
    addButton: 'Add',
    removeButton: 'Remove',
    inventoryCardTitle: 'Inventory Actions',
    inventoryCardSubtitle: 'Quickly adjust stock levels and keep counts accurate.',
    // For language toggle
    english: 'English',
    arabic: 'عربي',
    logout:'Logout'
  },
  ar: {
    workersDashboard: 'لوحة العمال',
    explanationText:
      'مرحبًا بك في لوحة العمال. أدر تعديلات مخزون المنتجات من هنا.',
    addButton: 'إضافة',
    removeButton: 'إزالة',
    inventoryCardTitle: 'إجراءات المخزون',
    inventoryCardSubtitle: 'عدّل مستويات المخزون بسرعة وحافظ على الدقة.',
    // For language toggle
    english: 'English',
    arabic: 'عربي',
    logout: 'تسجيل الخروج',
  },
};

const DashboardView = () => {
  // 2) Add language state and translation helper
  const [language, setLanguage] = usePersistentLanguage();
  const t = (key) => translations[language][key];

  // 3) Toggle language function
  const toggleLanguage = () => {
    setLanguage((prevLang) => (prevLang === 'en' ? 'ar' : 'en'));
  };

  const navigate = useNavigate();

  // Handlers for navigation with action context
  const handleAddClick = () => {
    navigate('/product-management', { state: { action: 'add' } }); // Pass "add" action context
  };

  const handleRemoveClick = () => {
    navigate('/product-management', { state: { action: 'remove' } }); // Pass "remove" action context
  };
  return (
    <AppLayout
      title={t('workersDashboard')}
      language={language}
      languageLabel={language === 'en' ? t('arabic') : t('english')}
      onToggleLanguage={toggleLanguage}
      showLogout
      logoutLabel={t('logout')}
      contentClassName={styles.dashboardView}
    >
      <div className={styles.explanationText}>
        <p>
          {t('explanationText')}
        </p>
      </div>

      <div className={styles.buttonContainer}>
        <article className={styles.actionCard}>
          <h2 className={styles.cardHeading}>{t('inventoryCardTitle')}</h2>
          <p className={styles.cardSummary}>{t('inventoryCardSubtitle')}</p>
          <div className={styles.cardActions}>
            <button className={styles.actionButton} onClick={handleAddClick}>
              <i className="fas fa-plus"></i> {t('addButton')}
            </button>
            <button
              className={`${styles.actionButton} ${styles.danger}`}
              onClick={handleRemoveClick}
            >
              <i className="fas fa-minus"></i> {t('removeButton')}
            </button>
          </div>
        </article>
      </div>
    </AppLayout>
  );
};

export default DashboardView;
